var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgae1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 115,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 63l1-1c0-2 1-3 3-4l2-1h2l2 2v3l-3 4-3 5-4 4-3 3-3 8v10l1-5 1-4 2-3 2-1c1-1 2 0 3 1l1 2-1 5-4 11-2 4v2l3 7a86 86 0 012 5 246 246 0 015-12l3-2 3 2 1 2-1 7-4 8-5 11-2 7-2 3v1h-1l-1-1v-2l3-8v-4l-1-1-3-3-5-5-3-3v-3c0-2 1-3 2-2l3 1 5 5v-1l-3-8-2-4-5-6-6-9-2-5v-2c0-2 2-3 3-2l2 2 3 5 2 3v-1-7-3L8 71l-2-8v-5l1-2c0-1 2-2 3 0l2 2 1 4a79 79 0 011 7l3-9v-2c1-4 0-8-2-12l-2-6-2-5-1-3 2-2h2l1 2 4 5a32 32 0 012 8h1l1-15-1-1-4-5-4-3-2-1a17 17 0 01-6-7l1-2h3l6 4 3 3v-2l-4-6-3-6V2c0-2 2-3 3-2l2 2 3 5 2 8v0l1-4 2-5 2-2h2l2 3v3l-3 10v1l-2 7-1 7v1l1-1 2-5 2-1 1-1c2-1 3 0 4 1l1 4-2 6-5 8-6 7c-2 2-3 5-4 9z",
    fill: "#9A4C5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgae1);
export default __webpack_public_path__ + "static/media/algae-1.f37767dcdfb5466fd6a79480b6b9ee8a.svg";
export { ForwardRef as ReactComponent };